import axios from 'axios';
import { store } from '../store'
import { LOGIN_PATH } from '../constants'
import history from '../history'


class Api {
  constructor() {
    if(store.getState().app_token) axios.defaults.headers.common['Authorization'] = `Bearer ${store.getState().app_token.accessToken}`;

    //Response Interceptor
    axios.interceptors.response.use(function(response) {
      return response;
    }, function(error) {
      if(error.response.status === 401){
        history.push(LOGIN_PATH);
      }
      return Promise.reject(error);
    });

  }

  login(url, token) {
    return axios.get(url)
  }

  logout(url, params) {
    return axios.post(url, params)
  }

  createNewPlan(url, params){
    return axios.post(url, params)
  }

  updatePlan(url, params){
    return axios.put(url, params)
  }

  toggleRisk(url, params){
    return axios.put(url, params)
  }

  get(url, params) {
    return axios.get(url, params)
  }

  post(url, params) {
    return axios.post(url, params)
  }

  put(url, params) {
    return axios.put(url, params)
  }

  delete(url, params) {
    return axios.delete(url, params)
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/services/api.js